import React from 'react';
import useFetch from 'use-http';
import { useParams, useNavigate } from 'react-router-dom';
import Table from 'components/UI/Table';
interface RDStatus {
	countpassport: string;
	email: string;
	emailManager: string;
	id: string;
	manager: string;
	notBanner: string;
	number: string;
	reject: string;
}

export default function StoreStatusesByManager() {
	const { emailManager } = useParams();
	const navigate = useNavigate();

	const { get, loading, error } = useFetch();
	const [data, setData] = React.useState([]);

	const load = async () => {
		const result = (await get(`/api/stores/statusesByManager?emailManager=${emailManager}`)).filter(
			(item: RDStatus) => +item.notBanner !== 0 || +item.reject !== 0,
		);
		const resultLength: number = result.length;

		for (let index = 0; index < resultLength; index++) {
			result[index].storeName = (await get(`/api/stores/${result[index].number}`)).title;
		}

		setData(result);
	};

	React.useEffect(() => {
		load();
	}, []);

	const headers = [
		{
			value: 'number',
			title: 'Номер магазина',
			formatted: React.useCallback(
				(row: any) => {
					const routeChange = () => {
						const path = `/admin?storeNumber=${row.number}`;
						navigate(path);
					};
					return (
						<button 
							type="button"
							style={{ 
								textDecoration: 'underline', 
								background: 'none', 
								border: 'none', 
								color: 'inherit', 
								cursor: 'pointer',
								padding: 0,
								font: 'inherit'
							}} 
							onClick={routeChange}
						>
							{row.number}
						</button>
					);
				},
				[navigate],
			),
		},
		{ value: 'storeName', title: 'Название' },
		{ value: 'reject', title: 'Отклоненный фотоотчет' },
		{ value: 'notBanner', title: 'Не предоставлен фотоотчет' },
	];

	return (
		<div>
			{data && (
				<div>
					{error && 'Error!'}
					{loading && 'Загрузка...'}
					<Table headers={headers} rows={data} />
				</div>
			)}
		</div>
	);
}
